import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Button from '../ui/form/Button';
import Table from '../ui/Table';
import { PROJECTS_BY_USERS, USERS } from '../../api/GraphQL';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router';

const Main = styled.div`
  display: flex;
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin-left: -15px;
  padding: 15px;
  flex-direction: column;
`;

export default function List() {
  const { loading, data } = useQuery(USERS, {
    fetchPolicy: 'network-only',
  });
  const [getProjects, { data: projects }] = useLazyQuery(PROJECTS_BY_USERS);

  useEffect(() => {
    if (data) {
      getProjects({ variables: { ids: data.users.map((u) => u._id) } });
    }
  }, [data, getProjects]);

  const history = useHistory();
  const match = useRouteMatch();

  return (
    <Main>
      {projects?.projectsByUsers && (
        <Table
          data={projects?.projectsByUsers}
          columns={[
            { Header: 'ID', accessor: '_id' },
            { Header: 'Name', accessor: 'name' },
            {
              Header: 'Teams',
              accessor: (item) => {
                return item.teams?.map((t) => t?.name + ',');
              },
            },
            {
              Header: 'Owner',
              accessor: (item) => {
                return item.user?.username;
              },
            },
          ]}
          onRowSelect={(item) => {
            history.push('/projects/' + item._id);
          }}
        />
      )}
    </Main>
  );
}
